import { ECONOMY } from './economy.js';

// Street food and what it does for a tired player, at the prices of the economy file.
export const FOOD = {
  puffpuff: { name: 'puff-puff', price: 100, gain: 25 },
  bread: { name: 'bread', price: ECONOMY.bread, gain: 30 },
  plantain: { name: 'roasted plantain', price: 200, gain: 35 },
  meal: { name: 'a plate of fufu and njama njama', price: ECONOMY.meal, gain: 80 },
};
